<script setup>
import Card from "primevue/card"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import {computed, ref, watch} from "vue";
import { useFacilityStore } from "@/stores/facility.js";
import { RouterLink } from "vue-router";


const props = defineProps({
  facilityId: {
    type: [Number, String],
    required: true
  }
})

const ROWS_PER_PAGE = 5
const store = useFacilityStore()
const loading = ref(false)

const ROLE_LABELS = {
  CUSTOMER: 'Заказчик',
  GENERAL_CONTRACTOR: 'Генеральный Подрядчик',
  CONTRACTOR: 'Подрядчик',
}

async function ensureLoaded(id) {
  if (!id) return
  loading.value = true
  try {
    await store.loadFacilityParticipants(id)
  } finally {
    loading.value = false
  }
}

watch(
    () => props.facilityId,
    (id) => ensureLoaded(Number(id)),
    { immediate: true }
)

const participants = computed(() => store.participantsByFacility[Number(props.facilityId)] || [])
const showPaginator = computed(() => participants.value.length > ROWS_PER_PAGE)

</script>

<template>
  <Card>
    <template #title>
      <div class="w-full flex items-center justify-between px-4 gap-3 text-lg">
        <span>Организации</span>
      </div>
    </template>
    <template #content>
      <DataTable
          :value="participants"
          :paginator="showPaginator"
          :rows="ROWS_PER_PAGE"
          :loading="loading"
          responsive-layout="scroll"
          paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="от {first} до {last} из {totalRecords}"
          emptyMessage="Участников нет"
          class="text-sm "
      >
        <Column style="width: 100%">
          <template #body="{ data }">
            <RouterLink :to="`/customers/${data.customer_id}`" class="block hover:underline">
              <div class="font-semibold">
                {{ data.short_name }}
              </div>
              <div class="text-xs text-gray-500">
                {{ ROLE_LABELS[data.role] || data.role }}
              </div>
            </RouterLink>
          </template>
        </Column>
      </DataTable>
    </template>
  </Card>
</template>


<style scoped>

:deep(.p-datatable-thead > tr > th),
:deep(.p-datatable-tbody > tr > td) {
  border: none !important;
  background: transparent !important;
  border-bottom: none !important;
}

:deep(.p-datatable-tbody > tr > td) {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

:deep(.p-datatable-thead > tr > th) {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}


:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next) {
  height: 2rem;
  min-width: 2rem;

}

:deep(.p-card-body) {
  padding: 6px 0 8px;
}
</style>